export default __webpack_public_path__ + "static/media/harpreetLikhari.ffeb8063.webp";